export default __webpack_public_path__ + "static/media/knight.6822afd0.png";